const constants = {
    ACTIONS: {
      GET_ALL_DOCTORS_SUCCESS: 'GET_ALL_DOCTORS_SUCCESS',
    },
  };
  export default constants;